import React from "react";
var __jsx = React.createElement;
import Anchor from '../../atoms/Anchor';
function CTAs(_ref) {
  var _yextInfo$entities, _yextInfo$entities$, _yextInfo$entities2, _yextInfo$entities2$;
  var yextInfo = _ref.yextInfo;
  var ctas = [(yextInfo === null || yextInfo === void 0 ? void 0 : yextInfo.c_websiteBannerExpandedFirstCTA) || (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$entities = yextInfo.entities) === null || _yextInfo$entities === void 0 ? void 0 : (_yextInfo$entities$ = _yextInfo$entities[0]) === null || _yextInfo$entities$ === void 0 ? void 0 : _yextInfo$entities$.c_websiteBannerExpandedFirstCTA), (yextInfo === null || yextInfo === void 0 ? void 0 : yextInfo.c_websiteBannerExpandedSecondCTA) || (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$entities2 = yextInfo.entities) === null || _yextInfo$entities2 === void 0 ? void 0 : (_yextInfo$entities2$ = _yextInfo$entities2[0]) === null || _yextInfo$entities2$ === void 0 ? void 0 : _yextInfo$entities2$.c_websiteBannerExpandedSecondCTA)].filter(function (cta) {
    return (cta === null || cta === void 0 ? void 0 : cta.link) && (cta === null || cta === void 0 ? void 0 : cta.label);
  }).reverse();
  return __jsx(React.Fragment, null, ctas.map(function (cta, index) {
    return __jsx(Anchor, {
      key: index,
      to: cta.link,
      className: "nva-banner__cta",
      styleType: index === 0 ? 'secondary-anchor' : 'primary-anchor'
    }, cta.label);
  }));
}
export default CTAs;